import type { IApiDefaults } from '~/types';

export const ApiDefaults: IApiDefaults = {
    pageSize: 10,
    startPage: 1
};
